export enum RateSelectedErrors {
  APPLICATION_KEY_MISSING_OR_EXPIRED = 'APPLICATION_KEY_MISSING_OR_EXPIRED',
  INVALID_APPLICATION_KEY = 'INVALID_APPLICATION_KEY',
  INVALID_RATE_SELECTED = 'INVALID_RATE_SELECTED',
  LOS_IMPORT_ERROR = 'LOS_IMPORT_ERROR',
  MISSING_APPLICATION_KEY = 'MISSING_APPLICATION_KEY',
  MISSING_ENCODED_DATA = 'MISSING_ENCODED_DATA',
}
